var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 17.714,
    viewBox: "0 0 14.857 17.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1749",
    "data-name": "Rectangle 1749",
    width: 14.857,
    height: 17.714,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3134",
    "data-name": "Group 3134",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_156",
    "data-name": "Line 156",
    d: "M2.017,1.449a.8.8,0,0,1-.245-.039L-.245.762A.8.8,0,0,1-.762-.245.8.8,0,0,1,.245-.762l2.017.649a.8.8,0,0,1-.245,1.562Z",
    transform: "translate(4.412 5.26)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_157",
    "data-name": "Line 157",
    d: "M0,1.449A.8.8,0,0,1-.762.894.8.8,0,0,1-.245-.112L1.772-.762a.8.8,0,0,1,1.007.516A.8.8,0,0,1,2.262.762L.245,1.411A.8.8,0,0,1,0,1.449Z",
    transform: "translate(6.428 5.26)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_158",
    "data-name": "Line 158",
    d: "M0,2.748a.8.8,0,0,1-.8-.8V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V1.948A.8.8,0,0,1,0,2.748Z",
    transform: "translate(6.429 5.909)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_159",
    "data-name": "Line 159",
    d: "M4.706.8H0A.8.8,0,0,1-.8,0,.8.8,0,0,1,0-.8H4.706a.8.8,0,0,1,.8.8A.8.8,0,0,1,4.706.8Z",
    transform: "translate(4.076 11.753)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3133",
    "data-name": "Group 3133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3132",
    "data-name": "Group 3132",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8479",
    "data-name": "Path 8479",
    d: "M6.714.2h0a6.427,6.427,0,0,1,6.515,6.32,6.258,6.258,0,0,1-2.919,5.265,1.008,1.008,0,0,0-.443.861v.809a2.667,2.667,0,0,1-2.7,2.631H6.257a2.667,2.667,0,0,1-2.7-2.631v-.844a1.086,1.086,0,0,0-.533-.886A6.189,6.189,0,0,1,2.18,1.987,6.6,6.6,0,0,1,5.951.242,6.962,6.962,0,0,1,6.714.2Zm.458,14.286a1.066,1.066,0,0,0,1.1-1.031v-.809a2.6,2.6,0,0,1,1.177-2.206,4.665,4.665,0,0,0,2.184-3.919A4.826,4.826,0,0,0,6.714,1.8a5.3,5.3,0,0,0-.587.033A4.853,4.853,0,0,0,1.85,5.839a4.644,4.644,0,0,0,2.066,4.554,2.692,2.692,0,0,1,1.246,2.217v.844a1.066,1.066,0,0,0,1.1,1.031Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.15275f60c1a690475e64d0d7e3f348f5.svg";
export { ForwardRef as ReactComponent };